const baseUrl = CDN_URL;

export function assetUrl(uri) {
    return baseUrl
        ? new URL(uri, baseUrl)
        : new URL(uri, window.location.origin);
}
